import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate';
import { useState } from 'react';
import { Title, TextInput, Button, GenericError, TextField } from '../common';
import { useTranslation } from '../../hooks/translations/TranslationProvider';
import { confirmEmail } from '../../api/auth';
import { useLocation } from 'react-router-dom';
import { getSiteLocaleFromPathname, withSiteLocale } from '../../utils/helpers';

import './emailCode.css';

interface EmailCodeProps {
    email: string;
}

const EmailCode: React.FC<EmailCodeProps> = ({ email }) => {
    const { t } = useTranslation();
    const navigate = useLocalizedNavigate();
    const location = useLocation();
    const locale = getSiteLocaleFromPathname(location.pathname);

    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [emailCode, setEmailCode] = useState('');
    const [emailCodeError, setEmailCodeError] = useState<string | null>(null);

    const codeChangeHandler = (name: string, value: string) => {
        setEmailCode(value);
        setEmailCodeError(null);
    };

    const onConfirmEmailHandler = async (event: React.FormEvent) => {
        event.preventDefault();

        setIsLoading(true);

        if (!emailCode) {
            setEmailCodeError(t('errors.requiredField'));
            setIsLoading(false);
            return;
        }

        try {
            await confirmEmail(email, emailCode);

            navigate(
                `${withSiteLocale('/login', locale)}?email-confirmed=true`
            );
        } catch (error: any) {
            if (error.response.status === 401) {
                setEmailCodeError(t('errors.invalidToken'));
            } else {
                setError(true);
            }
        }
        setIsLoading(false);
    };

    if (error) {
        return <GenericError error={error} />;
    }

    return (
        <div className="email-code">
            <div className="email-code-title">
                <Title text={t('register.confirmEmail')} size="xxl" />
            </div>
            <TextField size="l">{t('register.confirmEmailText')}</TextField>
            <TextField size="l">{t('register.confirmEmailText2')}</TextField>
            <form onSubmit={onConfirmEmailHandler} className="register-form">
                <TextInput
                    label={t('register.emailCode')}
                    name="emailCode"
                    placeholder={t('register.emailCode')}
                    onChange={codeChangeHandler}
                    value={emailCode}
                    error={emailCodeError}
                />
                <Button
                    type="submit"
                    text={t('register.confirm')}
                    variant="green"
                    disabled={isLoading}
                />
            </form>
        </div>
    );
};

export default EmailCode;
